<template>
  <el-card :body-style="{ height: '100%', overflow: 'auto' }" class=" h-full">
    <div class="mb-20px flex items-center">
      <el-button
        size="small"
        type="primary"
        @click="jumpHome"
        class="mr-10px"
        v-if="type !== 'update'"
      >
        {{ $t('返回') }}
      </el-button>
      <div class="border-l-3px border-$systemMainColor pl-10px">{{ title }}</div>
    </div>
    <div class="mb-20px flex h-36px">
      <div class="mr-10px h-36px leading-36px">计划月度</div>
      <el-date-picker
        size="small mr-10px"
        v-model="time"
        type="month"
        :placeholder="$t('请选择日期')"
        value-format="yyyy-MM"
        :disabled="type !== 'create'"
        @change="timeChange"
      >
      </el-date-picker>
      <!-- 新增和编辑要显示 详情不显示 -->
      <el-button size="small" type="primary" v-if="type !== 'read'" @click="addTableData">
        {{ $t(' 新增行数') }}
      </el-button>
    </div>
    <div :class="type === 'read' ? 'h-[calc(100%-100px)]' : 'h-[calc(100%-156px)]'">
      <el-table :data="allTableData" v-loading="tableLoading" ref="table" border height="100%">
        <el-table-column type="index" :label="$t('序号')" width="50" />
        <el-table-column :label="`${$t('部门')}`">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.deptId"
              :disabled="type === 'read' || scope.row.disableEdit"
            >
              <el-option
                v-for="(option, index) in organizationData"
                :key="index"
                :label="`${$t(option.displayName)}`"
                :value="option.id"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          :label="`${$t(item.label)}`"
          v-for="(item, index) in tableColums"
          :key="index"
        >
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row[item.prop]"
              size="mini"
              :min="0"
              class="w-full"
              @blur="blur(scope.row[item.prop])"
              :disabled="type === 'read'"
              :step="1000"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column :label="$t('操作')" width="200" v-if="type !== 'read'">
          <template slot-scope="scope">
            <el-button size="mini" @click="operateBtn(scope.row, 'delete')">
              {{ $t('删除') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="w-full mt-20px flex justify-center items-center" v-if="type !== 'read'">
      <el-button size="small" type="primary" :disabled="!save || !time" @click="updateTableData">
        {{ $t('保存') }}
      </el-button>
      <el-button size="small" type="primary" @click="cancel">
        {{ $t('取消') }}
      </el-button>
    </div>
  </el-card>
</template>

<script>
// tool
import { get, forEach, filter, omit, map, isEmpty, isNil, merge, size, concat } from 'lodash'
import { generateGUID } from '@/assets/js/Common'
import dayjs from 'dayjs'
// api
import { RoyaltiesTargetApi } from '@wiz-api/workbench'
import { OrganizationApi } from '@wiz-api/abp-identity'

const royaltiesTargetApi = new RoyaltiesTargetApi()
const organizationApi = new OrganizationApi()
export default {
  data() {
    return {
      allTableData: [],
      selfAddTableData: [], // 用户新增的表格数据
      requestTableData: [], // 请求的表格数据
      deleteTableData: [], // 删除请求回来得数据
      tableLoading: true,
      organizationData: [],
      tableColums: [
        {
          prop: 'companyLevelTarget',
          label: '内网目标',
        },
        {
          prop: 'provinceLevelTarget',
          label: '广东目标',
        },
        {
          prop: 'groupLevelTarget',
          label: '集团目标',
        },
      ],
      time: '',
      save: true, // 控制保存按钮的disable状态 保存按钮默认是可以点击的 当其中一个input框校验没通过 就不允许点击
    }
  },
  computed: {
    // read 详情 || update 编辑
    type() {
      return get(this.$route.query, 'type') || ''
    },
    title() {
      if (this.type === 'read') {
        return this.$t('宣传月度目标详情')
      }
      if (this.type === 'update') {
        return this.$t('编辑宣传月度目标')
      }
      return this.$t('新增宣传月度目标')
    },
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  methods: {
    async getDetailData() {
      this.tableLoading = true
      const [err, res] = await royaltiesTargetApi.list({ time: this.time })
      if (!err) {
        this.requestTableData = map(res, (item) => {
          return {
            ...item,
            time: dayjs(item.time).format('YYYY-MM-01 HH:mm:ss'),
            disableEdit: this.type === 'update',
          }
        })
        this.allTableData = concat(this.requestTableData, this.selfAddTableData)
        this.tableLoading = false
      }
    },
    async getOrganizations() {
      this.tableLoading = true
      const [err, res] = await organizationApi.getAllListDetails({
        filter: '',
        sorting: '',
      })
      if (!err) {
        forEach(res.items, (item) => {
          this.organizationData.push(...(get(item, 'children') || {}))
        })
        this.tableLoading = false
      }
    },
    addTableData() {
      if (!this.time) {
        this.$message.error(this.$t('请先选择日期'))
        return
      }
      this.selfAddTableData.push({
        rowId: generateGUID(),
        id: '00000000-0000-0000-0000-000000000000',
        deptId: isEmpty(this.organizationData) ? 0 : get(this.organizationData[0], 'id'),
        companyLevelTarget: 0,
        provinceLevelTarget: 0,
        groupLevelTarget: 0,
        time: dayjs(this.time).format('YYYY-MM-01 HH:mm:ss'),
      })
      this.allTableData = concat(this.requestTableData, this.selfAddTableData)
    },
    // rowId 是新增行数手动添加的 再发请求之前已经删掉 因此 只有rowId存在就是自己手动删除 不需要发请求
    async operateBtn(row) {
      if (row.rowId) {
        this.selfAddTableData = filter(this.selfAddTableData, (item) => {
          return item.rowId !== row.rowId
        })
        this.allTableData = concat(this.requestTableData, this.selfAddTableData)
        this.$message.success(this.$t('删除成功'))
        return
      }
      const [err, res] = await royaltiesTargetApi.callDelete({
        id: get(row, 'id'),
      })
      if (!err) {
        this.getDetailData()
        this.$message.success(this.$t('删除成功'))
        this.deleteTableData.push(row)
      }
    },
    // 新增(id: 00000000-0000-0000-0000-000000000000) || 编辑
    async updateTableData() {
      // 这里删除tableData里面每个对象的rowId

      this.selfAddTableData = map(this.selfAddTableData, (item) => {
        return omit(item, 'rowId')
      })
      this.allTableData = concat(this.requestTableData, this.selfAddTableData)
      if (size(this.allTableData) === 0 && this.type === 'create') {
        this.$message.error('请至少新增一条数据数据')
        return
      }
      const [err, res] = await royaltiesTargetApi.update({
        body: this.allTableData,
      })
      if (!err) {
        this.$message.success(this.$t('更新成功'))
        this.jumpHome()
      }
    },
    blur(val) {
      if (isNil(val)) {
        this.save = false
        this.$message.error(this.$t('目标数值不能空 请重新输入'))
        return
      }
      this.save = true
    },
    jumpHome() {
      this.$router.push({
        path: `${this.routerBase}/portal-management/royalties-management/promote-monthly-goals`,
      })
    },
    async cancel() {
      // 删除请求回来的数据 需要通过请求去删除 但是用户删除之后 进行取消操作 应该把删除的数据重新添加回来
      if (size(this.deleteTableData) > 0) {
        this.selfAddTableData = map(this.selfAddTableData, (item) => {
          return omit(item, 'rowId')
        })
        this.allTableData = concat(this.requestTableData, this.deleteTableData)
        const [err, res] = await royaltiesTargetApi.update({
          body: this.allTableData,
        })
        if (!err) {
          this.jumpHome()
          return
        }
      }
      this.jumpHome() // 并未对请求回来的数据进行操作 可直接返回首页
    },
    // 选择时间
    async timeChange(time) {
      if (time) {
        const [err, res] = await royaltiesTargetApi.list({ time })
        if (!err) {
          this.requestTableData = map(res, (item) => {
            return {
              ...item,
              time: dayjs(item.time).format('YYYY-MM-01 HH:mm:ss'),
              disableEdit: this.type === 'update',
            }
          })
          this.tableLoading = false
        }
      }
    },
  },
  async created() {
    this.time = get(this.$route.query, 'time') || ''
    await this.getOrganizations()
    if (this.type !== 'create') {
      await this.getDetailData()
    }
  },
}
</script>
